import { RouterProvider } from "react-router-dom";
import { protectedRoutes } from "./protectedRoutes";
import { publicRoutes } from "./publicRoutes";
import { useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { adminRoutes } from "./adminRoutes";
import { superAdminRoutes } from "./superAdminRoutes";
import { USER_TYPES } from "@root/constants";

const Router = () => {
  const isLoggedInUser: any = useSelector(getLoggedInUser);

  const getRoutes = () => {
    if (isLoggedInUser?.roleId === USER_TYPES.SUPER_ADMIN) {
      return superAdminRoutes;
    }
    if (isLoggedInUser?.roleId === USER_TYPES.ADMIN || isLoggedInUser?.roleId === USER_TYPES.ORGANIZATION_ADMIN) {
      return adminRoutes;
    }
    if (isLoggedInUser?.roleId === USER_TYPES.USER) {
      return protectedRoutes;
    }
    return publicRoutes;
  };

  return <RouterProvider router={getRoutes()} />;
};

export default Router;
